export default {
  spherePowerList: [],
  cylindricalPowerList: [],
  axisPowerList: [],
  additionalPowerList: [],
  distancesList: [],
  ReferralDoctors: [],
};
